import type { ReactNode } from 'react';

interface CpmEmptyStateProps {
    title: string;
    description?: string;
    action?: ReactNode;
}

export default function CpmEmptyState({ title, description, action }: CpmEmptyStateProps) {
    return (
        <div
            className="flex flex-col items-center justify-center text-center"
            style={{ gap: 12, padding: '52px 20px' }}
        >
            <div
                className="rounded-[18px] border-[1.5px] border-dashed border-[var(--cpm-border-strong)] bg-[var(--cpm-surface-subtle)] flex items-center justify-center"
                style={{ width: 72, height: 72 }}
            >
                <svg
                    width="28"
                    height="28"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="var(--cpm-text-tertiary)"
                    strokeWidth="1.8"
                >
                    <path
                        d="M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01"
                        strokeLinecap="round"
                    />
                </svg>
            </div>
            <h3 className="m-0 !text-[15px] !font-extrabold !text-[var(--cpm-text-primary)]">
                {title}
            </h3>
            {description ? (
                <p className="m-0 max-w-md !text-[13px] !font-medium !text-[var(--cpm-text-secondary)]">
                    {description}
                </p>
            ) : null}
            {action}
        </div>
    );
}
